import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  autocompleteWrapStyle: {
    flex: 1,
  },
}));

export default useStyles;
